/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgramMetaData } from './ProgramMetaData';
import {
    ProgramMetaDataFromJSON,
    ProgramMetaDataFromJSONTyped,
    ProgramMetaDataToJSON,
} from './ProgramMetaData';

/**
 * 
 * @export
 * @interface ProgramReference
 */
export interface ProgramReference {
    /**
     * UUID of the Program
     * @type {string}
     * @memberof ProgramReference
     */
    id: string;
    /**
     * 
     * @type {ProgramMetaData}
     * @memberof ProgramReference
     */
    metaData: ProgramMetaData;
}

/**
 * Check if a given object implements the ProgramReference interface.
 */
export function instanceOfProgramReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "metaData" in value;

    return isInstance;
}

export function ProgramReferenceFromJSON(json: any): ProgramReference {
    return ProgramReferenceFromJSONTyped(json, false);
}

export function ProgramReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'metaData': ProgramMetaDataFromJSON(json['metaData']),
    };
}

export function ProgramReferenceToJSON(value?: ProgramReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'metaData': ProgramMetaDataToJSON(value.metaData),
    };
}

